// extracted by mini-css-extract-plugin
module.exports = {"container":"BenefitTab_container__wu8Wl","title":"BenefitTab_title__pI6ld"};